import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { SplitAndClassify } from './containers/SplitAndClassify';
import { BankStatementExtract } from './containers/BankStatementExtract';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/split-and-classify" element={<SplitAndClassify />} />
        <Route path="/bank-statement-extract" element={<BankStatementExtract />} />
        <Route path="*" element={<Navigate to="/split-and-classify" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
